import { Button } from 'common/components/Button/Button'
import { BUTTON_MODIFIER, BUTTON_PROPORTION } from 'common/constants/buttonConstants'

import FailIcon from '../assets/fail.svg?react'

import styles from './failed-view.module.scss'

type Props = {
  message?: string
  onCancel: () => void
  onTryAgain: () => void
}

const DEFAULT_MESSAGE = "The terminal didn't complete the transaction. Please try again."

export const FailedView = ({ message = DEFAULT_MESSAGE, onCancel, onTryAgain }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <FailIcon width={72} height={72} />
      </div>
      <div className={styles.textGroup}>
        <h3 className={styles.title}>Payment failed</h3>
        <p className={styles.subtitle}>{message}</p>
      </div>
      <div className={styles.footer}>
        <Button
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onTryAgain}
          className={styles.tryAgainButton}>
          Try again
        </Button>
        <Button
          modifier={BUTTON_MODIFIER.SECONDARY}
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onCancel}
          className={styles.cancelButton}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
